export enum PlayerErrorType {
  TOKEN_ERROR = 'TOKEN_ERROR',
  URL_ERROR = 'URL_ERROR',
}